import { Inject, Module, OnModuleInit } from '@nestjs/common';
import { TokenService } from './services/token.service';
import { JwtService } from '@nestjs/jwt';
import { JWT_SECRET } from '@ip6m/server/config';
import { ServerFeatureConfigurationModule } from '@ip6m/server/feature-configuration';
import * as Joi from 'joi';
import { ServerDataAccessUserModule } from '@ip6m/server/data-access-user';

@Module({
  imports: [ServerFeatureConfigurationModule, ServerDataAccessUserModule],
  providers: [
    {
      provide: JwtService,
      useFactory: (jwtSecret: string) => new JwtService({ secret: jwtSecret }),
      inject: [JWT_SECRET],
    },
    TokenService,
  ],
  exports: [TokenService],
})
export class ServerAuthModule implements OnModuleInit {
  constructor(@Inject(JWT_SECRET) private jwtSecret: string) {}

  onModuleInit(): any {
    const schema = Joi.object({ jwtSecret: Joi.string().min(5) });
    Joi.assert(this, schema);
  }
}
